import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { IoIosSend } from "react-icons/io";
import { Link, NavLink } from "react-router-dom";
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { VscCallOutgoing } from "react-icons/vsc";
import { SiLeetcode } from "react-icons/si";
import toast from "react-hot-toast";
import Spinner from "../Components/Spinner";

const Contact = () => {
  const form = useRef();
  const [loadingState, setLoadingState] = useState(false);

  function sendEmailHandler(event) {
    event.preventDefault();
    setLoadingState(true);
    emailjs
      .sendForm(
        "service_u1apn5s",
        "template_10mww25",
        form.current,
        "6-VKc8i-ohQGUVTNJ"
      )
      .then((result) => {
        if (result.status === 200) {
          setLoadingState(false);
          toast.success("Email sent successfully...");
          event.target.reset();
        }
      })
      .catch((error) => {
        setLoadingState(false);
        toast.error("Network error...");
      });
  }

  return (
    <div className="w-full relative">
      <div className="mx-3 sm:mx-12">
        <div className="max-w-[1200px] mx-auto my-8">
          <h1 className="text-center text-4xl xl:text-left xl:text-7xl text-[#e84949] font-medium contact-heding">
            Contact Me
          </h1>
          <h2 className="text-center text-xl xl:text-left xl:text-5xl text-[#343d68aa] font-medium contact-sub-heding">
            Questions, Thoughts Or Just Want To Say Hello?
          </h2>

          {/* form-container */}
          <div className="mt-10 form-container">
            <form
              ref={form}
              onSubmit={sendEmailHandler}
              className="flex flex-col  gap-7 w-[80%] md:w-[70%] mx-auto my-8 form-container-inner"
            >
              <input
                required
                type="text"
                placeholder="Enter your name"
                name="user-name"
                className="w-[100%] h-10 px-8 text-lg rounded-md bg-[#ffffff97] font-medium contact-me-input-field "
              />
              <input
                required
                type="email"
                placeholder="Enter your email address"
                name="user-email"
                className="w-[100%] h-10 px-8 text-lg rounded-md bg-[#ffffff97] font-medium contact-me-input-field "
              />
              <input
                required
                type="text"
                placeholder="Enter your subject"
                name="user-subject"
                className="w-[100%] h-10 px-8 text-lg rounded-md bg-[#ffffff97] font-medium contact-me-input-field "
              />
              <textarea
                required
                name="user-message"
                placeholder="Enter your message"
                cols="30"
                rows="10"
                className="pt-4 w-[100%] px-8 text-lg rounded-md bg-[#ffffff97] font-medium contact-me-input-field overflow-x-auto"
              />
              <button
                className="flex self-center xl:self-start gap-4 rounded-md items-center bg-[#e84949] w-fit 
                    text-white py-3 px-9 contact-me-submit-button font-medium text-xl contact-submit-btn"
              >
                Send Message
                {loadingState ? <Spinner /> : <IoIosSend fontSize="2rem" />}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* footer */}
      <footer className="bg-[#343d68] py-2 sm:py-3 md:py-5 lg:py-10 xl:py-20 relative footer-container">
        <div className="flex flex-col xl:flex-row gap-4 p-5 items-center justify-between max-w-[1200px] mx-auto text-white relative footer-container-inner">
          <div className="flex gap-5 footer-nav-container">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/projects">Projects</NavLink>
            <NavLink to="/skills">Skills</NavLink>
          </div>

          <div className="flex flex-col xl:flex-row flex-wrap items-center gap-4 text-4xl footer-container-inner">
            <Link
              to="tel:+919586049357"
              className="flex items-center gap-2 text-lg footer-contact-no"
            >
              <VscCallOutgoing /> <span>+91 9586049357</span>
            </Link>
            <div className="flex flex-wrap items-center gap-4 footer-contact-icons">
              <NavLink
                target="_blank"
                to="https://www.linkedin.com/in/rahul-bhutaiya/"
              >
                <FaLinkedin />
              </NavLink>
              <NavLink target="_blank" to="https://github.com/Rahul-Bhutaiya">
                <FaGithub />
              </NavLink>
              <NavLink
                target="_blank"
                to="https://www.instagram.com/rahul.bhutaiya/"
              >
                <FaInstagram />
              </NavLink>
              <NavLink target="_blank" to="https://leetcode.com/u/szVFXhMYRp/">
                <SiLeetcode />
              </NavLink>
            </div>
          </div>
        </div>

        <h2 className="absolute bottom-0 left-0 text-3xl sm:text-4xl md:text-5xl lg:text-7xl text-[#535c87] select-none pb-1.5 lg:pb-3 footer-rahul-text">
          Rahul Bhutaiya
        </h2>
      </footer>
    </div>
  );
};

export default Contact;
